import { isEmpty } from "@king-ict/eupisi-ui/utils";
import { TFunction } from "i18next";
import * as yup from "yup";

interface Props {
  t: TFunction;
}

const RequestValidationSchema = ({ t }: Props) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
    parentNumberId: yup.mixed().test("notEmpty", requiredMsg, function (value) {
      return !isEmpty(value);
    }),
  });
};

export default RequestValidationSchema;
